import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {

constructor(private http:HttpClient) { }

GetFullDate():Observable<any>{
  return this.http.get(environment.BaseUrl + "Daro/General/GetFullDate").pipe(
    map(data=>{
      return data as any
    })
  )
}

GetNormalDate():Observable<any>{
  return this.http.get(environment.BaseUrl + "Daro/General/GetNormalDate").pipe(
    map(data=>{
      return data as any
    })
  )
}

GetPeriod():Observable<any>{
  return this.http.get(environment.BaseUrl + "Daro/General/GetPeriod").pipe(
    map(data=>{
      return data as any
    })
  )
}

}
